import { useLimitedActivityStore as useGlobalLimitedActivityStore } from 'lib/store/limitedActivityStore';
import { useLimitedActivityStoreContext } from 'lib/components/LimitedActivityStoreContext';
import { createLimitedActivityStore, LimitedActivityType } from 'lib/store/createLimitedActivityStore';

interface LimitedActivityStore extends ReturnType<typeof createLimitedActivityStore> {
  isNewUserOnly?: boolean;
  limitedActivityType?: LimitedActivityType;
}

export const useLimitedActivityStoreAuto = (): LimitedActivityStore => {
  try {
    const contextStore = useLimitedActivityStoreContext();
    return contextStore;
  } catch (error) {
    return useGlobalLimitedActivityStore;
  }
};
